module.exports = __webpack_public_path__ + "img/3d_Attendance.a960c39e.png";